const events = [
  {
    thumb: 'assets/imgs/events/geocart26.png',
    date: "26-28 Aug'26",
    title: "GeoCart'2026 - Mapping in Times of Need",
    place: 'Wellington, NZ',
    role: 'presented',
    url: 'https://cartography.org.nz/geocart2026',
    html: "<i class='fa fa-map'></i> https://cartography.org.nz/geocart2026",
  },
  {
    thumb: 'assets/imgs/events/ozchi25.jpg',
    date: "29 Nov - 3 Dec'25",
    title: 'OzCHI 2025',
    place: 'Sydney, AU',
    role: 'presented',
    url: 'http://jquery404.github.io/#/r/xrgait',
    html: "<i class='fab fa-pagelines'></i> https://ozchi.org/2025/",
  },
  {
    thumb: 'assets/imgs/events/nzgdc25.jpg',
    date: "25-27 Sep'25",
    title: 'NZGDC 2025 - Kiwi Games Zone',
    place: 'Wellington, NZ',
    role: 'presented',
    url: 'http://jquery404.github.io/#/r/jigshare',
    html: "<i class='fab fa-pagelines'></i> https://nzgdc.com/",
  },
  {
    thumb: 'assets/imgs/events/ieeevr24.png',
    date: "16-21 Mar'24",
    title: 'IEEEVR 2024',
    place: 'Orlando, FL, USA',
    role: 'presented',
    url: 'http://jquery404.github.io/#/r/avatar360',
    html: "<i class='fab fa-pagelines'></i> https://ieeevr.org/2024/",
  },
  {
    thumb: 'assets/imgs/events/siggraph_asia23.png',
    date: "16-20 Oct'23",
    title: 'SIGGRAPH Asia 2023',
    place: 'Sydney, AU',
    role: 'presented',
    url: 'http://jquery404.github.io/#/r/rtauditorium',
    html: "<i class='fab fa-pagelines'></i> https://asia.siggraph.org/2023/",
  },
  {
    thumb: 'assets/imgs/events/ismar23.jpg',
    date: "16-20 Oct'23",
    title: 'ISMAR 2023',
    place: 'Sydney, AU',
    role: 'presented',
    url: 'http://jquery404.github.io/#/r/mrmac',
    html: "<i class='fa fa-globe'></i> https://ismar23.org/",
  },
  {
    thumb: 'assets/imgs/events/vrst23.jpg',
    date: "9-11 Oct'23",
    title: 'VRST 2023',
    place: 'Christchurch, NZ',
    role: 'presented',
    url: 'http://jquery404.github.io/#/r/vicarious',
    html: "<i class='fa fa-spider'></i> https://vrst.acm.org/vrst2023/",
  },
  {
    thumb: 'assets/imgs/events/siggraph23.png',
    date: "6-10 Aug'23",
    title: 'SIGGRAPH 2023',
    place: 'Los Angeles, USA',
    role: 'presented',
    award: 'Audience Choice Award',
    url: 'https://s2023.siggraph.org/presentation/?id=real_106&sess=sess258',
    relatedResearch: ['rtstage'],
    html: "<i class='fab fa-pagelines'></i> https://s2023.siggraph.org/",
  },
  {
    thumb: 'assets/imgs/events/siggraph22.png',
    date: "6-9 Dec'22",
    title: 'SIGGRAPH Asia 2022',
    place: 'Daegu, South Korea',
    role: 'presented',
    url: 'https://sa2022.siggraph.org',
    html: "<i class='fab fa-pagelines'></i> https://sa2022.siggraph.org/",
  },
  {
    thumb: 'assets/imgs/events/ieeevr22.png',
    date: "12-16 Mar'22",
    title: 'IEEE VR Conference 2022',
    place: 'Christchurch, New Zealand',
    role: 'presented',
    url: 'https://ieeevr.org/2022/',
    html: "<i class='fab fa-pagelines'></i> https://ieeevr.org/2022",
  },
  {
    thumb: 'assets/imgs/events/nzgdc21.jpg',
    date: "4-6 Aug'21",
    title: 'NZGDC 2021 : Indie Biz Showcase',
    place: 'Wellington, New Zealand',
    role: 'presented',
    url: 'https://nzgdc.com/',
    html: "<i class='fab fa-pagelines'></i> https://tinyurl.com/s7n5d7wf",
  },
  {
    thumb: 'assets/imgs/events/gisnz.jpg',
    date: "17-18 Apr'21",
    title: 'TakiWaehere – New Zealand Geospatial Hackathon',
    place: 'by MBIE and Maxar',
    role: 'attended',
    url: 'https://tinyurl.com/y5ce3s7f',
    html: "<i class='fab fa-github'></i> https://tinyurl.com/y5ce3s7f",
  },
  {
    thumb: 'assets/imgs/events/aucxr.jpg',
    date: "9-12 Feb'21",
    title: 'International XR (AR/VR) Workshop',
    place: 'Auckland, University of Auckland',
    role: 'attended',
    url: 'https://tinyurl.com/6jaj765v',
    html: "<i class='fab fa-github'></i> https://tinyurl.com/6jaj765v",
  },
  {
    thumb: 'https://github.com/jquery404/ccrpg/raw/main/resources/1.jpg',
    date: "16 Aug'20",
    title: 'SWEN 422: CCRPG',
    place: 'Victoria University of Wellington',
    role: 'presented',
    url: 'https://tinyurl.com/zac5dde3',
    html: "<i class='fab fa-github'></i> https://tinyurl.com/zac5dde3",
  },
];

export { events };
